import React, { useEffect, useState, useRef } from 'react';
import axios, { formToJSON } from 'axios';
import { useParams } from 'react-router-dom';
import $, { data } from 'jquery';
import 'select2';
import '../css/Select2.css';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import '../css/new.css';
import reloadToken from '../helper/reloadtoken';
import helperFilter from '../helper/helperfilter';
import HeaderMenu from '../template/HeaderMenu';
import { apiConfig } from '../helper/apiConfig';
import { hide, sumDataKerja, getFrozen, createRatioZoom, getRatioZoom, saveheighrow, getheighrow, removeComma, getFilterPageAll, getFilterPageAllJson } from '../helper/hide';
import { ToastContainer, toast } from 'react-toastify';
import { dataconfig, showtoolbarConfig } from '../helper/luckysheetHelper';
import 'react-toastify/dist/ReactToastify.css';
import Modal from './modal_doc_perusahaan';
import Modalpreview from './modalpreview';
import Convertformatlucky from '../helper/convertformatlucky';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Message from '../helper/messages';
import { encrypt, decrypt, AesEncrypt } from '../helper/Decrypte';
import messages from '../helper/messages';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';

const title_form = "DATA KARYAWAN / GROUP";
const tipedata = "KARYAWAN";
const historyback = 'perusahaan'
const mainhost = process.env.REACT_APP_API_HOST_MASTER;
const hostcc = process.env.REACT_APP_API_HOST_COLOR_COMMENT;
const hostdrop = process.env.REACT_APP_API_HOST_DROPDOWN;
const hostdatcont = process.env.REACT_APP_API_HOST_DATA_CONT;

const API_COLUMN = mainhost + "KaryawanColumn"
const API_VALUES = mainhost + "KaryawanValue"
const API_CREATE_ID = mainhost + "KaryawanValue/New"
const API_STATUS_FILE = mainhost + "Cekstatusfile"
const API_UPDATE_COMMENT = hostcc + "Updatecomment"
const API_UPDATE_WARNA = hostcc + "ColorBrcontainers"
const API_UPDATE = mainhost + "KaryawanUpdate"
const API_PASTE = mainhost + "KaryawanPaste"
const API_PT_DROPDOWN = mainhost + "PerusahaanForDropdown"

var luckysheet;
let savedColumnWidths;
let data_all = []
let data_all_default = []
let data_all_reset = []
const currentUrl = window.location.href;
const fullURL = currentUrl.substring(0, currentUrl.lastIndexOf('/'));
const savePT = "PT-" + fullURL;
const saveNamaPT = "NAMAPT-" + fullURL;
const searchvalue = "SEARCH-" + fullURL;

const notify_cant_update_br_cont = (message, time = 800) => {
  toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const notify_update_br_cont = (message, time = 2000) => {
  toast.success(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const Karyawan = () => {
  const token = localStorage.getItem('token');
  const config = apiConfig(token);
  var b = 0;
  const pagecolumn = "KYCOLUMN"
  const pagerow = "KYROW"
  var options = null;
  var type_row = "";
  var type_jml = 0;
  var end_column_freze = 11;
  var size_scroll_left = 0;
  var defaultRowHeight = 30;
  var defaultratio = 1;

  var nama_column = [];
  let datahasil = [];
  let cellDataJsonA = [];
  let totaldata = 0;

  const [modalVisible, setModalVisible] = useState(false);
  const [datamodal, setDataModal] = useState(false);
  const [modalVisible_V, setModalVisible_V] = useState(false);
  const [datamodal_V, setDataModal_V] = useState(false);
  const selectForPT = useRef(null);
  const [TokenNew, setToken] = useState(null);
  const { param1, param2 } = useParams();
  const [selectPT, setselectPT] = useState('');
  const [selectNamaPT, setselectNamaPT] = useState('');
  const [optionsSearchPort, setoptionsSearchPort] = useState([]);
  const [searchvaluedata, setselectContainer] = useState(getFilterPageAll(searchvalue));
  const [namaColumn, setNamaColumn] = useState();

  const [datacell, set_datacell] = useState([]);

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  };

  const toggleModal_V = () => {
    setModalVisible_V(!modalVisible_V);
  };

  const handleChange = () => {

  }

  const handleBackClick = () => {
    const hostUrl = window.location.origin;
    window.location.href = hostUrl + "/" + historyback;
  };

  function findDataByCondition(data, condition) {
    if (!Array.isArray(data) || data.length === 0) {
      console.log("Data array is empty.");
      return [];
    }
    const foundData = [];
    data.forEach(item => {
      if (condition(item)) {
        foundData.push(item);
      }
    });

    // Return the found data
    return foundData;
  }

  const fkisearch = (event) => {
    const modifiedValue = event.target.value;
    setselectContainer(modifiedValue);
    if (modifiedValue === "") {
      localStorage.removeItem(searchvalue);
      window.location.reload();
    } else {
      localStorage.setItem(searchvalue, modifiedValue);
    }
  }

  function resetsearch(){
    localStorage.removeItem(searchvalue);
    window.location.reload();
  }

  function search() {
    console.log("namaColumn ", namaColumn)
    if (searchvaluedata == "") {
      // cellDataJsonA = data_all_reset;
      // totaldata = totaldata + cellDataJsonA.totaldata + 1;
      // CreateTable(data_all_reset)
    } else {
      const searchData = findDataByCondition(data_all.data, item => item.v.m.includes(searchvaluedata));
      if (searchData.length > 0) {
        data_all_default.data = searchData;
      var jml_all = 0;
      var jml_cari = 0;
      var sheet = luckysheet.getLuckysheetfile();
      var data_cari = luckysheet.find(searchvaluedata)
      if (sheet) {
        jml_all = sheet[0].data.length
      }
      if (data_cari) {
        jml_cari = data_cari.length
      }

      data_all = sheet[0].data;
      console.log(data_cari)
      let rowsToDelete = [];
      if (data_all && data_all.length) {
        data_all.forEach(row => {
          row.forEach(cell => {

            let found = false;
            if (data_cari && data_cari.length > 0) {
              data_cari.forEach(cariItem => {
                if (cell.row === cariItem.row) {
                  found = true;
                }
              });
              if (!found) {
                if (cell.row > 0 && !rowsToDelete.includes(cell.row)) {

                  var id = luckysheet.getCellValue(cell.row, 0)
                  console.log(id)
                  rowsToDelete.push(cell.row);
                }
              }
            }
          });
        });
      } else {
        console.error("data_all is not defined or has no length property");
      }

      rowsToDelete.sort((a, b) => b - a);
      rowsToDelete.forEach(row => {
        luckysheet.deleteRow(row, row);
      });
    } else {
      console.log("No matching data found.");
    }
    }
  }

  function callFunctionlocalstorage() {
    const frozenPosition = getFrozen();
    end_column_freze = frozenPosition;

    const ratiozoom = getRatioZoom();
    
    if (ratiozoom == null || ratiozoom == "" || ratiozoom == undefined) {
      defaultratio = 1;
    } else {
      defaultratio = ratiozoom;
    }

    const h_c = getheighrow();
    if (h_c == null || h_c == "") {
      defaultRowHeight = 30;
    } else {
      defaultRowHeight = h_c;
    }
  }

  const handleSelectChange = (event) => {
    const selectedOption = event.target.options[event.target.selectedIndex].text;
    const selectValue = event.target.options[event.target.selectedIndex].value;

    if (selectValue != "") {
      setTimeout(() => {
        setselectPT(selectValue);
        setselectNamaPT(selectedOption);
        localStorage.setItem(savePT, selectValue);
        localStorage.setItem(saveNamaPT, selectedOption);
        const newId = selectValue;

        const currentUrl = window.location.href;
        const parts = currentUrl.split('/');
        parts[parts.length - 1] = newId;
        const newUrl = parts.join('/');
        window.history.replaceState(null, '', newUrl);
        window.location.reload();
      }, 0);
    }
  };

  $(selectForPT.current).on('change', handleSelectChange);

  const fetchDropdownOptions = async () => {
    try {
      const config = apiConfig(token);
      const response = await axios.post(`${API_PT_DROPDOWN}`, null, config);
      return response.data;
    } catch (error) {
      console.error('Error fetching column names:', error);
      return [];
    }
  };

  // Call the async function and set the options when the data is retrieved
  const setDropdownOptions = async () => {
    const options = await fetchDropdownOptions();
    setoptionsSearchPort(options);
  };

  //set lebar kolom
  savedColumnWidths = JSON.parse(localStorage.getItem(pagecolumn));
  if (savedColumnWidths === null || Object.keys(savedColumnWidths).length === 0) {
    savedColumnWidths = null;
  } else {
    savedColumnWidths = savedColumnWidths;
  }


  const cekStatusFile = async () => {
    try {
      const response = await axios.post(`${API_STATUS_FILE}`, null, config);
      return response.data;
    } catch (error) {
      console.error(messages().file.error.e1, error);
      return [];
    }
  };


  async function cekFile() {
    let cekfile = await cekStatusFile();
    if (cekfile.length !== 0) {
      if (cekfile.count > 0) {
        setTimeout(async function () {
          var dataKirimModal = {
            id: "1",
            nama: "test"
          };
          setDataModal_V(dataKirimModal);
          toggleModal_V();
        }, 2000)
      }
    }
  }

  //1
  function CreateTable(pageData) {
    console.log("data ", pageData)
    callFunctionlocalstorage();
    const page0 = pageData || [];
    const merged = [
      ...page0.data,
    ];
    const mergedformula = [
      ...page0.dataformula,
    ];

    const mergedDataRO = page0.readonly;
    options = {
      container: "luckysheet",
      title: tipedata,
      lang: 'en',
      showinfobar: false,
      allowCopy: true,
      allowEdit: true,
      column: 0,
      filter: {
        ref: 'A1:C1',
      },
      forceCalculation: true,
      showtoolbarConfig: dataconfig,
      cellRightClickConfig: showtoolbarConfig,
      data: [
        {
          name: "Sheet",
          color: "",
          row: 1,
          index: "0",
          celldata: merged,
          calcChain: mergedformula,
          defaultRowHeight: defaultRowHeight,
          config: {
            columnlen: savedColumnWidths,
            colhidden: {
              0: false,
            },
            rowlen: {
              0: 40,
            },
            authority: {
              sheet: 1,
              hintText: "Kolom ini tidak bisa anda edit",
              allowRangeList: [
                {
                  "name": "area",
                  "sqref": mergedDataRO,
                },
              ],
            },
          },
        },
      ],
      enableAddRow: true,
      textWrapMode: true,
      hook: {
        cellRenderAfter: function (cell, position, sheetFile, ctx) {
          if (b < 1) {
            const data = [];
            const endIndex = 150;
            for (let i = 0; i <= endIndex; i++) {
              data.push(i);
            }
            var columnWidths = luckysheet.getColumnWidth(data);
            const colWidthA = columnWidths[1];
            for (let columnIndex of data) {
              const width = columnWidths[columnIndex];
              columnWidths[columnIndex.toString()] = width;
            }
            localStorage.setItem(pagecolumn, JSON.stringify(columnWidths));

            setTimeout(function () {
              b = 0;
            }, 500);
          }
          b++;
        },
        rangePasteBefore: function (range, data) { },
        commentUpdateBefore: async function (r, c, value) {
          const id = luckysheet.getCellValue(r, 0);
          const column = AesEncrypt(nama_column[c]);
          const formData = new FormData();
          const cleanedValue = value.trim().replace(/\r\n?|\n/g, ' ');
          formData.append("code_1", id);
          formData.append("code_2", tipedata);
          formData.append("code_3", "");
          formData.append("row", r);
          formData.append("col", c);
          formData.append("comment", cleanedValue);
          formData.append("column", column);
          try {
            const response = await axios.post(`${API_UPDATE_COMMENT}`, formData, config);
            notify_update_br_cont(messages().command.sukses.s1);
          } catch (error) {
            console.error("Gagal update warna : ", error);
          }
        },
        cellEditBefore: function (r, c, value, isRefresh) {
          // console.log("Edit before");
          //  console.log(value);
        },
        cellUpdateBefore: function (r, c, value, isRefresh) {
          return true;
          if (!isValidFormula(value)) {
            //console.info('cellUpdateBefore', r, c, value, isRefresh);
            return true;
          } else {
            //console.warn('Validation failed for cellUpdateBefore', r, c, value, isRefresh);
            return false;
          }
        },
        cellUpdated: function (r, c, oldValue, newValue, isRefresh) {
          if (oldValue && newValue) {
            if (luckysheet.getCellValue(r, 0) != "") {
              const id = luckysheet.getCellValue(r, 0);
              var vt, ct;
              var datax = {};
              var newdata = removeComma(newValue.m);
              var olddata = oldValue.m;
              if (nama_column[c] !== undefined) {
                if (newdata !== null && newdata !== undefined && newdata !== "") {
                  datax["data"] = newdata;
                } else {
                  datax["data"] = " ";
                }
                ct = nama_column[c];
                if (olddata !== newdata) {
                  if (olddata !== null && olddata != newdata && nama_column[c] != "") {
                    datax["id"] = id//AesEncrypt(id)
                    datax["old"] = olddata;
                    datax["ct"] = AesEncrypt(ct)
                    if (validasidropdown(nama_column[c], newdata)) {
                      axios.post(`${API_UPDATE}`, datax, config)
                        .then(response => {
                          if (response.data.status == "success")
                            notify_update_br_cont(messages(newdata).update.sukses.s1);

                        })
                        .catch(error => {
                          notify_cant_update_br_cont(error.response.data.message);
                          console.error(messages().all.error.error_update, error.response.data.message);
                          luckysheet.undo();
                        });
                    } else {
                      notify_cant_update_br_cont(messages().all.error.error_update_1);
                    }
                  }
                }
              } else {
                notify_cant_update_br_cont(messages().all.error.error_update_2);
              }
            } else {
              notify_cant_update_br_cont(messages().all.error.error_update_3);
            }
          }
        },
        cellEditBefore: function (range) {
          const c = range[0].column[0];
          var title_column_select = luckysheet.getCellValue(0, c);

        },
        rangeSelect: function (index, sheet) {
          var column = sheet[0].column[0];
          if (sheet[0].column[0] <= end_column_freze) {
            setleftScrollbar(true);
          } else {
            setleftScrollbar(false);
          }
          var top = sheet[0].top;
          var left = sheet[0].left;
          var height = sheet[0].height;
          var kiri = left;
          var atas = top;
          var tinggi = height;
          filter_data(column, top, left, height);

        },

        cellMousedown: function (cell, postion, sheetFile, ctx) {
          var dat = postion.r + "" + postion.c;
          if (type_row == dat) {
            type_jml++;
          } else {
            type_jml = 0;
          }
          type_row = postion.r + "" + postion.c;

          if (type_jml > 0) {
            if (cell.ct.t == "l") {
              const id = luckysheet.getCellValue(postion.r, 0);
              const judul = luckysheet.getCellValue(0, postion.c);
              var dataKirimModal = {
                id: id,
                nama: judul
              };
              setDataModal(dataKirimModal);
              toggleModal();
            } else if (cell.ct.t == "ur") {
              const id = luckysheet.getCellValue(postion.r, 0);
              const judul = luckysheet.getCellValue(0, postion.c);
              const url = cell.url;
              var dataKirimModal = {
                id: id,
                nama: judul
              };
              window.location.href = url;
            }
          }
        },

        afterzoomfiki: function (ration) {
          createRatioZoom(ration);
        },

        updated: function (operate) {
          let data = luckysheet.getLuckysheetfile();
          if (operate) {
            if (operate.ctrlType == "resizeR") {
              let dataukuran = operate.curconfig.rowlen;

              const keys = Object.keys(dataukuran);
              const lastKey = keys[keys.length - 1];
              const lastValue = dataukuran[lastKey];
              saveheighrow(lastValue);
            }
          }
        },
        aftertambahdata:function (data){
          var data = $("#luckysheet-bottom-add-row-input").val();
          var b = luckysheet.getRange()[0].row[0];
          for (var i = 1; i <= data; i++) {
            try {
              const response = axios.post(`${API_CREATE_ID}/${param1}/${param2}`, null, config);
              //luckysheet.setCellValue(b, 0, response.data.data);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
            b++;
          }
         window.location.reload();
        },
        afterkasihwarnacell: function (warna) {
          var title = $(this).attr('title');
          var datas = [];
          var jlh = 0;
          var selectedRange = luckysheet.getRange();
          if (!selectedRange) {
            console.error('No cells selected.');
            return;
          }
          var baris_awal = selectedRange[0].row[0];
          var baris_akhir = selectedRange[0].row[1];
          var kolom_awal = selectedRange[0].column[0];
          var kolom_akhir = selectedRange[0].column[1];

          const column = nama_column[kolom_awal];
          for (var row = baris_awal; row <= baris_akhir; row++) {
            for (var col = kolom_awal; col <= kolom_akhir; col++) {
              const id = luckysheet.getCellValue(row, 0);
              var datax = {};
              datax['id'] = id;
              datax['warna'] = warna;
              datax['ColumnName'] = AesEncrypt(column);
              datax['ColumnField'] = tipedata;
              datas[jlh] = datax;
              jlh++;
            }
          }
          var dataxx = {};
          dataxx['data'] = JSON.stringify(datas);
          if (column.length > 0){
          axios.post(`${API_UPDATE_WARNA}`, dataxx, config)
            .then((response) => {
              notify_update_br_cont("Color sukses di tambahkan");
            })
            .catch((error) => {
              console.error('Error fetching data:', error);
            });
        } else{
          notify_update_br_cont("Gagal menambahkan warna, silahkan refresh halaman dan ulangi kembali");
        }
      },
        rangePasteBeforefiki: function (range, data, fki) {
          console.log("range ", fki.luckysheetfile[0].luckysheet_select_save[0])
          // console.log("data ",fki)
          const isConfirmed = window.confirm('Yakin akan melakukan paste data?');
          if (isConfirmed) {
            setTimeout(() => {
              let jsonData = fki.luckysheetfile[0].luckysheet_select_save[0];
              const rows = jsonData.row;
              const columns = jsonData.column;
              // extra columnya fk
              const [startRow, endRow] = rows;
              const [startCol, endCol] = columns;

              var dataArray = [];
              var idCounter = 1;
              var datax = [];
              var transformedData = [];

              for (let row = startRow; row <= endRow; row++) {
                let id = luckysheet.getCellValue(row, 0, { type: "m" });
                if (id !== null && id !== undefined && id !== "") {
                  let ct = [];
                  let data = [];
                  for (let col = startCol; col <= endCol; col++) {
                    const nilai = luckysheet.getCellValue(row, col, { type: "m" });
                    ct.push(AesEncrypt(nama_column[col].toString().trim()));
                    data.push(nilai !== null && nilai !== undefined && nilai !== "" ? nilai.toString().trim() : "");
                  }
                  datax.push({ id: id.toString().trim(), ct: ct, data: data });
                }
              }

              datax.forEach((item) => {
                item.ct.forEach((ct, index) => {
                  transformedData.push({
                    id: item.id,
                    ct: ct,
                    data: item.data[index]
                  });
                });
              });

              UpdateFromPaste(transformedData);
            }, 400);
          } else {
            return false;
          }
        },
      },
    }

    options.loading = {
      image: () => {
        return `<svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none"></circle>
          </svg>`
      },
      imageClass: "loadingAnimation"
    }

    if (totaldata > 0) {
      luckysheet.create(options)
    } else {
      notify_cant_update_br_cont("Error, Tidak dapat tersambung dengan server!", 2500);
    }
  }

  function validasidropdown(kolom, data) {
    return true;
  }

  function UpdateFromPaste(datax) {
    console.log('POST request successful:', datax);
    axios.post(`${API_PASTE}`, datax, config)
      .then(response => {
        if (response.data.status == "success")
          notify_update_br_cont(response.data.message);
      })
      .catch(error => {
        console.error('Error fetching data:', error.response.data.message);
        notify_cant_update_br_cont(error.response.data.message);
        // luckysheet.setCellValue(r, c, "");
        luckysheet.refresh();
      });
  }

  function isValidFormula(value) {
    const formulaPattern = /^=([A-Za-z]+\d+\+)*[A-Za-z]+\d+$/;
    return formulaPattern.test(value);
  }

  function filter_data(c, atas, kiri, tinggi) {
    const datakolom = nama_column[c]

    $("#luckysheet-rich-text-editor").on('keyup', function () {
      const searchText = $("#luckysheet-rich-text-editor").text().toUpperCase();
      $("#luckysheet-dataVerification-dropdown-List").hide();
      $(".dropdown-List-item").each(function () {
        const itemText = $(this).text().toUpperCase();
        if (itemText.indexOf(searchText) > -1) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      // fiki
      const editorHeight = $("#luckysheet-rich-text-editor").outerHeight();
      const topValue = parseFloat($("#luckysheet-cell-selected-focus").css("top"));
      const leftValue = parseFloat($("#luckysheet-input-box").css("left"));

      $("#luckysheet-dataVerification-dropdown-List").css({
        display: 'block',
        // left: leftValue - 44 + 'px',
        // top: topValue + editorHeight + editorHeight - 5 + 'px',
        right: 'auto',
        left: kiri + 'px',
        top: atas + tinggi + 'px',
      });
    });
  }
  //2
  $(document).on('click', '.luckysheet-cols-menuitem', function () {
    helperFilter(11);
  });

  useEffect(() => {
    //TYPE
    luckysheet = window.luckysheet;
    $('.js-example-basic-single').select2();
    $('.js-example-basic-multiple').select2({
      theme: "classic"
    });

    $(selectForPT.current).select2({

    });

    const getIdFromUrl = () => {
      const urlParts = window.location.href.split('/');
      const id = urlParts[urlParts.length - 1];
      return id;
    };
    setselectPT(getIdFromUrl());
    setDropdownOptions();

    // cekFile();
    // const intervalId = setInterval(cekFile, 3600000);//1 jam

    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const newToken = await reloadToken();
      setToken(newToken);
    };

    new Promise((resolve) => setTimeout(resolve, 100));
    const getColumnNames = async () => {
      try {
        const config = apiConfig(token);
        const response = await axios.post(`${API_COLUMN}/${param1}/${param2}`, null, config);
        setNamaColumn(response.data.column)
        return response.data.column;
      } catch (error) {
        console.error(messages().column.error.e1, error);
        return [];
      }
    };

    const getColumnNames_c = async () => {
      const options = await getColumnNames();
      return options;
    };

    const getCellData = async (data, savedColumnWidths, urutanload) => {
      try {
        const response = await axios.post(`${API_VALUES}/${param1}/${param2}`, { data, savedColumnWidths, urutanload }, config);
        return response;
      } catch (error) {
        console.error(messages().value.error.e1, error);
        return [];
      }
    };

    const getCellData_c = async () => {
      const options = await getCellData();
      return options;
    };

    getColumnNames_c().then(result => {
      nama_column = result;
    }).catch(error => {
      console.error('Error:', error);
    });

    function isObjectEmpty(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    }

    async function loaddata(offset) {
      try {
        cellDataJsonA = await getCellData_c(datahasil, savedColumnWidths, offset);
        if (cellDataJsonA.length === 0) {
          return {
            "data": [{}],
            "dataformula": [{}]
          };
        } else {
          if (isObjectEmpty(cellDataJsonA.data)) {
            return {
              "data": [{}],
              "dataformula": [{}]
            };
          } else {
            totaldata = totaldata + cellDataJsonA.data.totaldata + 1;
            Convertformatlucky(cellDataJsonA)
          }
          data_all = cellDataJsonA.data;
          setselectNamaPT(cellDataJsonA.data.ot_data)
          return data_all;
        }
      } catch (error) {
        console.error('Error loading data:', error);
        return {
          "data": [{}],
          "dataformula": [{}]
        };
      }
    }

    const loaddata_c = async () => {
      const options = await loaddata(0); // Pass the offset here
      return options;
    };

    loaddata_c().then(result => {
      data_all_default = JSON.parse(JSON.stringify(result));
      data_all_reset = JSON.parse(JSON.stringify(result));
      CreateTable(result);
    }).catch(error => {
      console.error('Error:', error);
    });

    function getColumnPosition(columnNumber) {
      let dividend = columnNumber + 1;
      let columnName = '';

      while (dividend > 0) {
        const modulo = (dividend - 1) % 26;
        columnName = String.fromCharCode(65 + modulo) + columnName;
        dividend = Math.floor((dividend - modulo) / 26);
      }
      return columnName;
    }

    const luckysheetContainer = document.getElementById('luckysheet');
    luckysheetContainer.addEventListener('scroll', () => {
      const scrollLeft = luckysheetContainer.scrollLeft;
      const frozenColumns = document.querySelectorAll('.luckysheet-cell.luckysheet-cell-frozen');
      frozenColumns.forEach((column) => {
        column.style.transform = `translateX(${scrollLeft}px)`;
      });
    });

    const isMobileDevice =() =>{
      const mobileScreenWidth = 568;
      if (window.innerWidth < mobileScreenWidth){
        return true
      }
      return false;
    }

    setTimeout(function () {
      var calcChainLength = 0;
      if (totaldata > 0) {
        var total_data = luckysheet.getAllSheets()[0].data.length;
        calcChainLength = total_data + 1;
        luckysheet.setBothFrozen(true, { range: { row_focus: 0, column_focus: end_column_freze } });
        helperFilter(11);
        const mobileScreenWidth = 768;
        if (window.innerWidth > mobileScreenWidth){
          luckysheet.setSheetZoom(defaultratio);
        }
        setleftScrollbarstart();
      }

    }, 500);

    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // If token is not found in localStorage, reload it
      reloadToken().then(newToken => {
        setToken(newToken);
        // Store the token in localStorage for future use
        localStorage.setItem('token', newToken);
      });
    }

    fetchData();
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is hidden');
        luckysheet.refresh();
      } else {
        console.log('Tab is visible');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);


    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      // clearInterval(intervalId);
      $(selectForPT.current).off('change', handleSelectChange);
    };
  }, []);

  const convertToAlphabet = (number) => {
    let result = '';
    while (number >= 0) {
      result = String.fromCharCode(65 + (number % 26)) + result;
      number = Math.floor(number / 26) - 1;
    }
    return result;
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  function setleftScrollbar(kiri) {
    const luckysheetContainerX = document.getElementById('luckysheet-scrollbar-x');
    luckysheetContainerX.addEventListener('scroll', () => {
      if (luckysheetContainerX.scrollLeft > 1) {
        document.getElementById("luckysheet-dataVerification-dropdown-btn").style.setProperty('display', 'none', 'important');
        size_scroll_left = luckysheetContainerX.scrollLeft;
        const arrowCanvas = document.getElementById("arrowCanvas-overshow");
        if (arrowCanvas !== null) {
          document.getElementById("luckysheet-postil-overshow").style.display = "none";
        }
      }
    });
    if (kiri) {
      size_scroll_left = 1
      luckysheetContainerX.scrollLeft = size_scroll_left;
    }
    else {
      luckysheetContainerX.scrollLeft = size_scroll_left;
    }
  }

  function setleftScrollbarstart() {
    const luckysheetContainerX = document.getElementById('luckysheet-scrollbar-x');
    luckysheetContainerX.addEventListener('scroll', () => {
      if (luckysheetContainerX.scrollLeft > 1) {
        size_scroll_left = luckysheetContainerX.scrollLeft;
      }
      luckysheetContainerX.scrollLeft = size_scroll_left;
      // console.log("SCROLL AUTO", luckysheetContainerX.scrollLeft);
    });
  }



  const luckyCss = {
    margin: '75px 0px 0px 0px',
    padding: '0px',
    position: 'absolute',
    width: '100%',
    height: '90%',
    left: '0px',
    top: '0px',
    overflowX: 'auto',
  };

  const forumLinkStyle = {
    zIndex: 2,
    width: '50px',
    height: '50px',
    lineHeight: '50px',
    position: 'fixed',
    right: '40px',
    bottom: '86px',
    borderRadius: '50px',
    cursor: 'pointer',
    background: 'rgb(71,133,249)',
    color: '#fff',
    textAlign: 'center',
    textDecoration: 'none',
  };

  const selectStyle = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '400px',
    height: '10%',
    marginTop: '5px',
  };
  const labelStyel = {
    marginTop: '22px',
  };
  return (
    <div>
      <HeaderMenu title={`${title_form} | ${selectNamaPT || " "}`} subtitle={"Page data Karyawan"} />
      <ToastContainer />
      <div style={{ textAlign: 'center' }}>
        <table border={0}>
          <thead>
          </thead>
          <tbody>
            <tr>
              <td>
                <button onClick={handleBackClick} className='btn btn-reset btn-width-auto'>
                  <FontAwesomeIcon icon={faArrowLeft} /> Back
                </button>
              </td>
              <td><span className={labelStyel}>Data Perusahaan / Group</span></td>
              <td>:</td>
              <td>
                <select style={selectStyle} ref={selectForPT} className="js-example-basic-single style-select-report" value={selectPT || ""} onChange={handleChange}>
                  {optionsSearchPort.map((optionsSearchPort) => (
                    <option key={optionsSearchPort.value} value={optionsSearchPort.value}>
                      {optionsSearchPort.label}
                    </option>
                  ))}
                </select>
              </td>
              <td width={10}></td>
              <td><span className={labelStyel}>Cari data</span></td>
              <td>:</td>
              <td><input type="text" value={searchvaluedata || ""} onChange={fkisearch} className='inputsearch' /></td>
              <td>
                <button onClick={search} className='btn btn-search btn-width-auto'>
                  <FontAwesomeIcon icon={faSearch} /> Cari
                </button>
                <button onClick={resetsearch} className='btn btn-default btn-width-auto'>
                  <FontAwesomeIcon icon={faSearch} /> reset
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      <div id="luckysheet" className='luckyCssWithMenuResponsive' />
      <Modal modalVisible={modalVisible} toggleModal={toggleModal} data={datamodal} />
      <Modalpreview modalVisible={modalVisible_V} toggleModal={toggleModal_V} data={datamodal_V} />
    </div>
  );
};

export default Karyawan;